import { render } from "./3.AllPartners.vue?vue&type=template&id=5e23a3ad&scoped=true"
import script from "./3.AllPartners.vue?vue&type=script&lang=js"
export * from "./3.AllPartners.vue?vue&type=script&lang=js"

import "./3.AllPartners.vue?vue&type=style&index=0&id=5e23a3ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e23a3ad"]])

export default __exports__